module.exports = __webpack_public_path__ + "img/gardenia.png";